function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dd)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 16,
  width: 130,
  height: 130,
  rx: 10,
  fill: "#F45D58"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M66.4016 123.792C67.735 123.792 68.8083 124.192 69.6216 124.992C70.4483 125.792 70.8616 126.979 70.8616 128.552V134.712H67.7416V129.032C67.7416 128.179 67.555 127.546 67.1816 127.132C66.8083 126.706 66.2683 126.492 65.5616 126.492C64.775 126.492 64.1483 126.739 63.6816 127.232C63.215 127.712 62.9816 128.432 62.9816 129.392V134.712H59.8616V119.872H62.9816V125.072C63.395 124.659 63.895 124.346 64.4816 124.132C65.0683 123.906 65.7083 123.792 66.4016 123.792ZM83.937 129.372C83.937 129.412 83.917 129.692 83.877 130.212H75.737C75.8836 130.879 76.2303 131.406 76.777 131.792C77.3236 132.179 78.0036 132.372 78.817 132.372C79.377 132.372 79.8703 132.292 80.297 132.132C80.737 131.959 81.1436 131.692 81.517 131.332L83.177 133.132C82.1636 134.292 80.6836 134.872 78.737 134.872C77.5236 134.872 76.4503 134.639 75.517 134.172C74.5836 133.692 73.8636 133.032 73.357 132.192C72.8503 131.352 72.597 130.399 72.597 129.332C72.597 128.279 72.8436 127.332 73.337 126.492C73.8436 125.639 74.5303 124.979 75.397 124.512C76.277 124.032 77.257 123.792 78.337 123.792C79.3903 123.792 80.3436 124.019 81.197 124.472C82.0503 124.926 82.717 125.579 83.197 126.432C83.6903 127.272 83.937 128.252 83.937 129.372ZM78.357 126.152C77.6503 126.152 77.057 126.352 76.577 126.752C76.097 127.152 75.8036 127.699 75.697 128.392H80.997C80.8903 127.712 80.597 127.172 80.117 126.772C79.637 126.359 79.0503 126.152 78.357 126.152ZM85.6041 119.872H88.7241V134.712H85.6041V119.872ZM97.5698 123.792C98.5698 123.792 99.4764 124.026 100.29 124.492C101.116 124.946 101.763 125.592 102.23 126.432C102.696 127.259 102.93 128.226 102.93 129.332C102.93 130.439 102.696 131.412 102.23 132.252C101.763 133.079 101.116 133.726 100.29 134.192C99.4764 134.646 98.5698 134.872 97.5698 134.872C96.1964 134.872 95.1164 134.439 94.3298 133.572V138.592H91.2098V123.952H94.1898V125.192C94.9631 124.259 96.0898 123.792 97.5698 123.792ZM97.0298 132.312C97.8298 132.312 98.4831 132.046 98.9898 131.512C99.5098 130.966 99.7698 130.239 99.7698 129.332C99.7698 128.426 99.5098 127.706 98.9898 127.172C98.4831 126.626 97.8298 126.352 97.0298 126.352C96.2298 126.352 95.5698 126.626 95.0498 127.172C94.5431 127.706 94.2898 128.426 94.2898 129.332C94.2898 130.239 94.5431 130.966 95.0498 131.512C95.5698 132.046 96.2298 132.312 97.0298 132.312Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M97.7687 41.1553C93.0947 37.7851 87.2235 36.1 80.1551 36.1C74.78 36.1 70.2413 37.2849 66.5554 39.6588C60.7047 43.3734 57.5969 49.6833 57.2197 58.5803H70.7784C70.7784 55.985 71.5369 53.4963 73.0457 51.0855C74.5586 48.6829 77.1252 47.4816 80.7455 47.4816C84.4273 47.4816 86.9652 48.4574 88.3469 50.4049C89.7368 52.3606 90.4297 54.5213 90.4297 56.8911C90.4297 58.9575 89.3965 60.8476 88.146 62.5614C87.4008 63.6253 86.4851 64.559 85.4359 65.3248C85.4359 65.3248 78.0846 70.0398 74.8579 73.8282C72.9883 76.0217 72.8202 79.314 72.6521 84.029C72.6439 84.3652 72.771 85.0622 73.9436 85.0622H84.4847C85.5343 85.0622 85.7516 84.2873 85.7639 83.9388C85.8377 82.225 86.0263 81.3435 86.342 80.3513C86.9324 78.4776 88.5478 76.8458 90.3559 75.4354L94.0869 72.8647C97.4571 70.2366 100.143 68.0841 101.332 66.3949C103.357 63.6233 104.784 60.2039 104.784 56.1449C104.78 49.5234 102.443 44.5337 97.7687 41.1553V41.1553ZM79.9378 93.1884C75.2679 93.0449 71.4139 96.2798 71.2663 101.347C71.1228 106.407 74.7841 109.756 79.4581 109.892C84.333 110.035 88.0845 106.911 88.2362 101.843C88.3756 96.7759 84.8168 93.3319 79.9378 93.1884V93.1884Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_dd",
  x: 0,
  y: 0,
  width: 162,
  height: 162,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -4,
  dy: -4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 4,
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow",
  result: "shape"
})));

var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.d482a444.svg";
export { ForwardRef as ReactComponent };